import React, { useState } from 'react'
import { Modal } from '../../../../components/Modal/Modal'
import { Modal as BootstrapModal, Tab } from 'react-bootstrap'
import { CRMIntegrationSettings } from '../CRMIntegrationSettings'
import { Tabs } from '../../../../components/Tabs/Tabs'
import { CRMIntegrationTaskSettings } from '../CRMIntegrationTaskSettings'
import { ContactSyncSettings } from '../ContactSyncSettings'

export type PractifiSettingsModalProps = {
  show: boolean
  onHide: () => void
}

export const PractifiSettingsModal: React.FC<PractifiSettingsModalProps> = ({ show, onHide }) => {
  const [activeTabKey, setActiveTabKey] = useState<string>('practifiMappings')
  const changeTab = (key: string | null) => {
    if (key) {
      setActiveTabKey(key)
    }
  }

  const PractifiSettingsModalBody = () => {
    return (
      <Tabs activeKey={activeTabKey} id='practifi-settings' className='d-flex mb-3' onSelect={changeTab} mountOnEnter unmountOnExit>
        <Tab eventKey='practifiMappings' title='Mappings'>
          <CRMIntegrationSettings serviceId='practifi' onSaved={onHide} onCancelled={onHide} />
        </Tab>
        <Tab eventKey='practifiSyncSettings' title='Contact Sync'>
          <ContactSyncSettings serviceId={'practifi'} />
        </Tab>
        <Tab eventKey='practifyTaskSettings' title='Tasks'>
          <CRMIntegrationTaskSettings serviceId='practify' />
        </Tab>
      </Tabs>
    )
  }
  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<BootstrapModal.Title>Edit Practifi Integration Settings</BootstrapModal.Title>}
      body={<PractifiSettingsModalBody />}
    />
  )
}
